import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";
import type { Label } from "common/types";

import type { LabelType } from "../types";

async function getLabelsRequest(workspaceId: string, type: LabelType) {
  return (
    await get(
      `workspaces/${workspaceId}/${type === "workspace" ? "labels" : `${type}-labels`}`,
    )
  ).labels;
}

export default function useAllLabels(type: LabelType) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { labelsKeys } = getQueryKeys(workspaceId);

  const {
    data: allLabels,
    isLoading: isLoadingAllLabels,
    isError: isAllLabelsError,
    refetch: refetchAllLabels,
  } = useQuery<Label[]>({
    queryKey: labelsKeys.list(type),
    queryFn: () => getLabelsRequest(workspaceId, type),
    refetchOnMount: false,
  });

  return {
    allLabels,
    isLoadingAllLabels,
    isAllLabelsError,
    refetchAllLabels,
  };
}
